export default {
    getJobUrl: 'https://revfin.in/web/api/posts/',
    jobPostUrl: 'https://revfin.in/web/api/api/upload',
    cacheURL: window.location.href,
    password: "sjwwt67gg66AA87verw66091975t3chBPp"
}



// WEBPACK FOOTER //
// ./src/config/config.js